import { auth } from '@/shared/lib/auth';

/**
 * Updates a user profile on behalf of the Freshchat restore-id helper once an updater is registered.
 * Starts as a no-op resolving to undefined and is replaced by registerFreshchatUserUpdater.
 *
 * @returns A promise resolving to the update result, undefined until an updater is registered.
 */
let updateUserHandler: (args: { userId: any; userInfo: any }) => Promise<any> = async () =>
  undefined;
/**
 * Registers the user-update function the Freshchat restore-id helper calls, keeping the shared layer free of an entity import. Stores the handler in the module-level slot used by the restore-id updater.
 *
 * @param handler - User-update function to install.
 * @returns Nothing.
 */
export const registerFreshchatUserUpdater = (handler: typeof updateUserHandler) => {
  updateUserHandler = handler;
};

/**
 * Persists the Freshchat restore id so a returning user keeps their chat history. Writes the id into auth storage and pushes it onto the current user's profile through the registered update handler, logging and swallowing any failure.
 *
 * @param freshChatRestoreId - Freshchat restore id issued for the current user.
 * @returns Promise resolving once the id has been stored or the failure logged.
 */
const handleUpdateFreshChatRestoreId = async (freshChatRestoreId: any) => {
  try {
    auth.setFreshChatRestoreId(freshChatRestoreId);
    await updateUserHandler({
      userId: auth.userId(),
      userInfo: {
        freshChatRestoreId,
      },
    });
  } catch (error) {
    console.error('Failed to update Freshchat restore ID: ', error);
  }
};

export default handleUpdateFreshChatRestoreId;
